import { sessionManager } from "core/instances";
import { PermissionService } from "core/services/cef";

export const userStatus = {
    unknown: "Unknown",
    active: "Active",
    deleted: "Deleted",
    waitingForApproval: "WaitingForApproval",
    pendingRegistration: "PendingCIAMRegistration"
}

const _getUserDetailsAsync = async (throwExceptionIfNoData = false, update = false) => {
    const result = await new PermissionService().getUserDetails(true);

    const data = result?.data?.response;

    if (data == null || data[0].customerNumber == null) {
        //In theory if there was an issue, then axios would
        //throw an exception
        if (throwExceptionIfNoData) {
            throw new Error("Error getting user");
        }

        return { status: userStatus.unknown, customerNumber: undefined };
    }

    //The user could be linked to multiple customer numbers & the first might not be active
    const match = data.find(x => x.status === userStatus.active) ?? data[0];

    const status = match.status;

    const customerNumber = match.customerNumber;

    if (status === userStatus.active) {
        console.log(data);

        if (update) {
            sessionManager.updateLoggedInUser(data);
        }

        sessionManager.setLoggedInUser(data);
    }

    return { status, customerNumber };
}

/**
 * @description Gets the user details using the CEF api & then sets the SessionManager.loggedInUser if the user is active.
 * This then causes the appContext.user to get updated.
 * @returns The user status
 */
export const getUserDetailsAsync = async (throwExceptionIfNoData = false) => _getUserDetailsAsync(throwExceptionIfNoData);

/**
 * @description Gets the user details using the CEF api & then updates the SessionManager.loggedInUser if the user is active.
 * This then causes the appContext.user to get updated.
 * @returns The user status
 */
export const updateUserDetailsAsync = async (throwExceptionIfNoData = false) => _getUserDetailsAsync(throwExceptionIfNoData, true);

export default getUserDetailsAsync;
